import { Pipe, PipeTransform } from '@angular/core';
import { Schema } from '@app/core/_models/schema';

@Pipe({
  name: 'propertyGetEnumValues',
})
export class PropertyGetEnumValuesPipe implements PipeTransform {
  public transform(properties: Schema, controlName: string): string[] {
    return properties.getEnumValues(controlName);
  }
}
